module.exports = __webpack_public_path__ + "static/media/icon-piece-2.62e6d427.png";